import { render, staticRenderFns } from "./ShowAllNewOrders.vue?vue&type=template&id=556af43a&"
import script from "./ShowAllNewOrders.vue?vue&type=script&lang=js&"
export * from "./ShowAllNewOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports